import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWifiSignal = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 8,
	viewBox: "0 0 8 8",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		opacity: .75,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M4 7L0 3C0.416667 2.33333 2 1 4 1C6 1 7.58333 2.33333 8 3L4 7Z",
			fill: "currentColor"
		})
	})
});
export default SvgWifiSignal;
